module.exports = __webpack_public_path__ + "img/int6_jar_ros_01.57f3d90a.jpg";